<template>
  <div class="animated fadeIn">
    <tracking/>
    <br />
    <spinner v-if="loading == true"></spinner>
    <b-row>
      <b-col class="text-center">
        <b-button style="margin-bottom: 30px;" @click="goToDiv">Ir para desafio de Nutrição</b-button>
      </b-col>
    </b-row>
    <b-card header-tag="header" v-if="loading == false" style="background-color: #c9e7f1;">
      <b-card-body>
        <b-row v-if="loading == false">
          <b-col sm="12">
            <b-row style="margin-top: 60px;">
              <b-col sm="5" offset-sm="1" class="mobile">
                <iframe style="max-width: 100%" width="373" height="210" src="https://www.youtube.com/embed/LPcZZzu3FK8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </b-col>
              <b-col sm="4" offset-sm="1" style="font-family: 'Nunito Sans', sans-serif; font-weight: 400;">
                <h2 class="h2" style="margin-top: 20px;">Desafio online de emagrecimento para personal trainer | 7 dias</h2>
                <p class="lead my-4">
                   Todo o material para você fazer um grupo de emagrecimento pelo WhatsApp.
                </p>
                <ul class="list-unstyled mb-0">
                    <li class="py-2">
                        <div class="d-flex align-items-center">
                            <div>
                                <b-badge v-b-tooltip.hover variant="primary" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-check"></i></b-badge>
                            </div>
                            <div id="test" style="margin-left: 10px;">
                                <span class="h6 mb-0">Material para captação de participantes, execução do grupo e venda</span>
                            </div>
                        </div>
                    </li>
                    <li class="py-2">
                        <div class="d-flex align-items-center">
                            <div>
                                <b-badge v-b-tooltip.hover variant="primary" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-check"></i></b-badge>
                            </div>
                            <div id="test" style="margin-left: 10px;">
                                <span class="h6 mb-0">Posts</span>
                            </div>
                        </div>
                    </li>
                    <li class="py-2">
                        <div class="d-flex align-items-center">
                            <div>
                                <b-badge v-b-tooltip.hover variant="primary" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-check"></i></b-badge>
                            </div>
                            <div id="test" style="margin-left: 10px;">
                                <span class="h6 mb-0">Stories</span>
                            </div>
                        </div>
                    </li>
                    <li class="py-2">
                        <div class="d-flex align-items-center">
                            <div>
                                <b-badge v-b-tooltip.hover variant="primary" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-check"></i></b-badge>
                            </div>
                            <div id="test" style="margin-left: 10px;">
                                <span class="h6 mb-0">Mensagens do Whatsapp</span>
                            </div>
                        </div>
                    </li>
                    <li class="py-2">
                        <div class="d-flex align-items-center">
                            <div>
                                <b-badge v-b-tooltip.hover variant="primary" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-check"></i></b-badge>
                            </div>
                            <div id="test" style="margin-left: 10px;">
                                <span class="h6 mb-0">Roteiro para Live</span>
                            </div>
                        </div>
                    </li>
                </ul>
              </b-col>
              <b-col sm="5" offset-sm="1" class="desktop">
                <iframe width="640" height="360" src="https://www.youtube.com/embed/LPcZZzu3FK8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </b-col>
            </b-row>
            <b-row style="margin-top: 30px;">
              <b-col sm="12" class="text-center" v-if="me && me.subscription && (me.challengeAccess || me.admin || (!me.subscription.isExpired && me.subscription.planType == 'FREEPASS'))">
                <b-button @click="goToChallenge({_id: '61c4c2e1b145f14fdb9c230f'})" variant="primary">Acessar Desafio</b-button>
              </b-col>
              <b-col sm="12" class="text-center" v-else>
                <b-button @click="goToPayments()" variant="primary">Comprar Acesso por R$150</b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" id="challengenutri">
            <b-row style="margin-top: 60px;">
              <b-col sm="5" offset-sm="1" class="desktop">
                <iframe width="640" height="360" src="https://www.youtube.com/embed/2QteDLyD6Lo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </b-col>
              <b-col sm="5" offset-sm="1" class="mobile">
                <iframe style="max-width: 100%" width="373" height="210" src="https://www.youtube.com/embed/2QteDLyD6Lo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </b-col>
              <b-col sm="4" offset-sm="1" style="font-family: 'Nunito Sans', sans-serif; font-weight: 400;">
                <h2 class="h2" style="margin-top: 20px;">Desafio online de emagrecimento para nutricionista | 7 dias</h2>
                <p class="lead my-4">
                   Todo o material para você fazer um grupo de emagrecimento pelo WhatsApp.
                </p>
                <ul class="list-unstyled mb-0">
                    <li class="py-2">
                        <div class="d-flex align-items-center">
                            <div>
                                <b-badge v-b-tooltip.hover variant="primary" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-check"></i></b-badge>
                            </div>
                            <div id="test" style="margin-left: 10px;">
                                <span class="h6 mb-0">Material para captação de participantes, execução do grupo e venda</span>
                            </div>
                        </div>
                    </li>
                    <li class="py-2">
                        <div class="d-flex align-items-center">
                            <div>
                                <b-badge v-b-tooltip.hover variant="primary" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-check"></i></b-badge>
                            </div>
                            <div id="test" style="margin-left: 10px;">
                                <span class="h6 mb-0">Posts</span>
                            </div>
                        </div>
                    </li>
                    <li class="py-2">
                        <div class="d-flex align-items-center">
                            <div>
                                <b-badge v-b-tooltip.hover variant="primary" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-check"></i></b-badge>
                            </div>
                            <div id="test" style="margin-left: 10px;">
                                <span class="h6 mb-0">Stories</span>
                            </div>
                        </div>
                    </li>
                    <li class="py-2">
                        <div class="d-flex align-items-center">
                            <div>
                                <b-badge v-b-tooltip.hover variant="primary" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-check"></i></b-badge>
                            </div>
                            <div id="test" style="margin-left: 10px;">
                                <span class="h6 mb-0">Mensagens do Whatsapp</span>
                            </div>
                        </div>
                    </li>
                    <li class="py-2">
                        <div class="d-flex align-items-center">
                            <div>
                                <b-badge v-b-tooltip.hover variant="primary" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-check"></i></b-badge>
                            </div>
                            <div id="test" style="margin-left: 10px;">
                                <span class="h6 mb-0">Material complementar (PDF)</span>
                            </div>
                        </div>
                    </li>
                    <li class="py-2">
                        <div class="d-flex align-items-center">
                            <div>
                                <b-badge v-b-tooltip.hover variant="primary" title="Escolha a capa, o título e coloque sua logo. Selecione entre mais de 100 páginas de conteúdo."><i class="fa fa-check"></i></b-badge>
                            </div>
                            <div id="test" style="margin-left: 10px;">
                                <span class="h6 mb-0">Roteiro para Live</span>
                            </div>
                        </div>
                    </li>
                </ul>
              </b-col>
            </b-row>
            <b-row style="margin-top: 30px;">
              <b-col sm="12" class="text-center" v-if="me && me.subscription && (me.challengeAccess || me.admin || (!me.subscription.isExpired && me.subscription.planType == 'FREEPASS'))">
                <b-button @click="goToChallenge({_id: '614a32e0b145f14fdb972b5b'})" variant="primary">Acessar Desafio</b-button>
              </b-col>
              <b-col sm="12" class="text-center" v-else>
                <b-button @click="goToPayments()" variant="primary">Comprar Acesso por R$150</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import service from "../service";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import { isMobile } from "mobile-device-detect";
import Spinner from "./Spinner";
import { isIOS } from "mobile-device-detect";
import Tracking from './Tracking.vue';

export default {
  name: "Challenge",
  props: {
    isMine: false
  },
  data: function() {
    return {
      currentPage: 1,
      perPage: 24,
      totalPages: 1,
      selectedCategories: [],
      taggingSelected: null,
      includeExpress: true,
      includeAdvanced: true,
      loading: true,
      onlyIncludeAdvanced: false,
      modalShow: false,
      noTemplateUsed: false,
      searchId: "",
      isMobileScreen: isMobile,
      isIOS: isIOS,
      nextPageIndex: 1,
      me: undefined,
      pages: [],
      showPersonalChallenge: false
    };
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    hotCategories() {
      let hotCategories = [];

      if (this.categoriesList && this.categoriesList.length) {
        for (let key in this.categoriesList) {
          if (this.categoriesList[key].hot) {
            hotCategories.push(this.categoriesList[key])
          }
        }
      }
      
      return hotCategories;
    }
  },
  created: function() {
    this.modalShow = true;

    if (localStorage.sessionId) {
      service.getMe().then(me => {
        if (!me.subscription.editionCount) {
          this.noTemplateUsed = true;
        }

        this.me = me;

        if (this.me && this.me.subscription.planType && this.me.subscription.planType == "FREEPASS") {
          this.showPersonalChallenge = true;
        }
        
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  },
  methods: {
    goToPayments: function() {
      let url = "https://pag.ae/7XAm6H-zp";

      window.location.href = url;
    },
    goToDiv() {
      document.getElementById('challengenutri').scrollIntoView();
    },
    showModal() {
      this.showModal = true;
    },
    hideModal() {
      this.$refs["bv-modal-example"].hide();
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["bv-modal-example"].toggle("#toggle-btn");
    },
    goToChallenge: function(challenge) {
      let route = '/challenge/' + challenge._id;
      this.$router.push(route);
    }
  },
  components: { VueBootstrapTypeahead, Spinner, Tracking }
};
</script>
    Tracking

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



<style lang="css" scoped>
.background-multiSelect >>> .multiselect__tag {
  background: #20a8d8 !important;
}
.center-text {
  text-align: center !important;
}
.margin-extra {
  margin: 20px !important;
  width: unset !important;
}
</style>
